export default "__VITE_ASSET__8y9oYsIx__"